<template>
 <div>
  <map-info-modal ref="mapInfoModalRef">
   <label slot="title">车辆动态信息</label>
   <div slot="content" v-if="currentClickedVehicleInfo">
    <div v-if="!content.registrationNum">
     <label>车架号：</label><label>{{content.vin}}</label>
    </div>
    <div v-if="content.registrationNum"><label>车牌：</label>
     <div
      :style="{backgroundColor:registrationColorCompute(content.registrationColor),width:'fit-content', height:'22px', padding:'3px','border-radius': '3px', display:'inline-block'}">
      <label
       :style="{color: registrationTextColorCompute(content.registrationColor)}">{{content.registrationNum}}</label>
     </div>
    </div>
    <div>
     <div style="display: inline;"><label>运行状态：</label><label style="color: #3399FF;">{{content.terminalState}}</label>
     </div>
     <div style="display: inline-block; margin-left: 10px;"><label>持续时长：</label><label
      style="color: #3399FF;">{{content.terminalStateSpan}}</label></div>
    </div>
    <div><label>定位时间：</label><label style="color: #3399FF;">{{content.gpsDatetime}}</label>
    </div>
    <div>
     <div style="display: inline;"><label>行驶速度：</label><label style="color: #3399FF;">{{content.speed}}</label>
     </div>
     <div style="display: inline; margin-left: 10px;"><label>方向：</label><label
      style="color: #3399FF;">{{content.direction}}</label></div>
     <div style="display: inline; margin-left: 10px;"><label>累计里程：</label><label
      style="color: #3399FF;">{{content.mileage}}</label></div>
    </div>
    <div><label>位置：</label><label
     style="color: #3399FF;">{{content.address}}</label></div>
    <div><label>状态：</label><label
     style="color: #3399FF;">{{content.state}}</label></div>
    <div><label>报警：</label><label
     style="color: #3399FF;">{{content.alarm}}</label></div>
    <div style="margin-top: 8px;">
     <Button size="small" style="margin-right: 5px;" @click="onZoomToVehicleClick">缩放</Button>
<!--     <Button size="small" style="margin-right: 5px;"-->
<!--             @click="onQueryTripsClick(content.registrationNum==null?content.vin:content.registrationNum)">-->
<!--      查看行程-->
<!--     </Button>-->
     <Button size="small" style="margin-right: 5px;"
             @click="onhistory(content.registrationNum==null?content.vin:content.registrationNum)">
      轨迹回放
     </Button>
    </div>
   </div>
  </map-info-modal>
 </div>
</template>
<script>

  import {GPS} from '@/libs/positonUtils'
  import {reqReverseGeocoder} from '@/libs//baidumaputil'
  import {registrationTextColor, registrationColor} from '@/libs/registrationutil'

  import MapInfoModal from '@/view/ddm/components/map-info-windows/map-info-modal'

  export default {
    name: 'vehicleinfomodal',
    components: {
      MapInfoModal
    },
    props: {},
    data() {
      return {
        mapInfoModalRef: null,
        currentClickedVehicleInfo:null,
        content: {
          // 显示内容
          vin: null,
          registrationColor: null,
          registrationNum: null,
          speed: null,
          mileage: null,
          direction: null,
          gpsDatetime: null,
          alarm: null,
          state: null,
          address: null,
          terminalState: null,
          terminalStateSpan: null
        }
      }
    },
    methods: {
      /**
       * 封装车牌颜色底色方法
       */
      updateCurrentClickedVehicleInfoToContent() {
        this.content.vin = this.currentClickedVehicleInfo.vin
        this.content.registrationColor = this.currentClickedVehicleInfo.registrationColor
        this.content.registrationNum = this.currentClickedVehicleInfo.registrationNum
        this.content.speed = this.currentClickedVehicleInfo.info.speed
        this.content.mileage = this.currentClickedVehicleInfo.info.mileage
        this.content.direction = this.currentClickedVehicleInfo.info.direction
        this.content.gpsDatetime = this.currentClickedVehicleInfo.info.gpsDatetime
        this.content.alarm = this.currentClickedVehicleInfo.info.alarm
        this.content.state = this.currentClickedVehicleInfo.info.state
        this.content.address = this.currentClickedVehicleInfo.info.address
        this.content.terminalState = this.currentClickedVehicleInfo.info.terminalState
        this.content.terminalStateSpan = this.currentClickedVehicleInfo.info.terminalStateSpan
      },
      /**
       * 封装车牌颜色底色方法
       */
      registrationColorCompute(val) {
        return registrationColor(val)
      },
      /**
       * 封装车牌颜色文字颜色方法
       */
      registrationTextColorCompute(val) {
        return registrationTextColor(val)
      },
      /**
       * 查看行程
       */
      onQueryTripsClick(name) {
        this.$router.push({name: 'locatehodometer', params: {name: name}})
      },
     /**
      * 轨迹回放
      */
     onhistory(name) {
      this.$router.push({name: 'test', params: {registrationNum: name}})
     },
      /**
       * 缩放至车辆
       */
      onZoomToVehicleClick() {
        this.mapInfoModalRef._map.centerAndZoom(this.mapInfoModalRef.beforeMapPoint, 16)
      },
      getDisplay(){
        return this.mapInfoModalRef.display
      },
      onMapPan(delta) {
        this.mapInfoModalRef.onMapPan(delta)
      },
      onMapPanEnd(delta) {
        this.mapInfoModalRef.onMapPanEnd(delta)
      },
      onMapZoom() {
        this.mapInfoModalRef.onMapZoom()
      },
      onMapZoomEnd() {
        this.mapInfoModalRef.onMapZoomEnd()
      },
      onClose() {
        this.mapInfoModalRef.onClose()
        this.currentClickedVehicleInfo = null
        this.content.vin = null
        this.content.registrationColor = null
        this.content.registrationNum = null
        this.content.speed = null
        this.content.mileage = null
        this.content.direction = null
        this.content.gpsDatetime = null
        this.content.alarm = null
        this.content.state = null
        this.content.address = null
        this.content.terminalState = null
        this.content.terminalStateSpan = null
      },
      moveModalByDelta(deltaScreenX, deltaScreenY) {
        this.mapInfoModalRef.moveModalByDelta(deltaScreenX, deltaScreenY)
      },
      moveModal(screenX, screenY) {
        this.mapInfoModalRef.moveModal(screenX, screenY)
      },
      moveModalByWebPoint(webPoint){
       this.mapInfoModalRef.moveModalByWebPoint(webPoint)
      },
      showModalByLatLng(map, arcgisModules, wgs84Lng, wgs84Lat) {
        this.mapInfoModalRef.showModalByLatLng(map, arcgisModules, wgs84Lng, wgs84Lat)
      },
      showModal(map, arcgisModules, webX, webY) {
        this.mapInfoModalRef.showModal(map, arcgisModules, webX, webY)
      }
    },
    computed: {},
    mounted() {
      this.$nextTick(() => {
        this.mapInfoModalRef = this.$refs.mapInfoModalRef
        this.mapInfoModalRef.styleData.height = 260;
        this.mapInfoModalRef.styleData.width = 300;
      })
    }
  }

</script>
<style lang="less">

</style>
